import { Falcon } from 'modules/macro';
import { StyledIconButton } from './styled';
export function ResetButton(props) {
    const { show, label, onClick } = props;
    if (!show) {
        return null;
    }
    return (<StyledIconButton type="button" appearance="ghost" size="small" aria-label={label} onClick={onClick}>
      <Falcon icon="xmark" $color="text.100"/>
    </StyledIconButton>);
}
